import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { saveAs } from 'file-saver';
import { notificationInit } from '../../modules/notifications/actions';
import { REQUEST_ERROR_MESSAGE } from './constants';
import {
	GET_LEGALS,
	GET_LIST_LEGAL_FILE_TYPES,
	setLegalsAction,
	setPaginationAction,
	setIsLegalsLoadingAction,
	setIsDownloadLoadingAction,
} from './actions';
import { DISMISS_TIME } from '../../api/constants';
import { getLegalsRequest } from '../../api/legals-requests';
import { getBlobForReqListRequest } from '../../api/requests';
import { errorHandler } from '../../api/utils';

export function* getLegalsSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsLegalsLoadingAction(true));
		}

		const { data, message, meta, toast } = yield call(getLegalsRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}
			yield put(
				setLegalsAction(
					data?.map(legal => ({
						...legal,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=legal&id=${legal.id}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsLegalsLoadingAction(false));
	}
}

export function* getReqListFileSaga({ payload: { exportUrl } }) {
	try {
		yield put(setIsDownloadLoadingAction(true));
		const blob = yield call(getBlobForReqListRequest, exportUrl);

		saveAs(blob, 'legals.xlsx');
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsDownloadLoadingAction(false));
	}
}

export default function* legalsSaga() {
	yield takeEvery(GET_LEGALS, getLegalsSaga);
	yield takeEvery(GET_LIST_LEGAL_FILE_TYPES, getReqListFileSaga);
}
